import React from "react";
import LegalPage from "./LegalPage";

const PrivacyPolicy = () => <LegalPage type="privacy" />;

export default PrivacyPolicy;
